<template>
  <div id="app">
    <div :class="{'low': hasScrolled }" class="navbar-container position-fixed d-flex flex-center">
      <div class="custom-navbar z-depth-1 h-100 d-flex justify-content-between">
        <a href="/" class="h-100">
          <img class="navbar-logo h-100" src="./assets/NueLogoHorizontalWhite.svg" alt="">
        </a>
        <div class="navbar-buttons-container h-100 d-flex">
          <div class="navbar-dropdown-button-container">
            <div class="navbar-button h-100 d-flex flex-column flex-center">
                <div>Productos <i class="fas fa-chevron-down"></i></div>
            </div>
            <div class="dropdown-content products">
              <div class="d-flex justify-content-start align-items-center pl-2">
                DataWrap
              </div>
              <div class="d-flex justify-content-start align-items-center pl-2">
                Deliveras
              </div>
              <div class="d-flex justify-content-start align-items-center pl-2">
                Here-it
              </div>
            </div>
          </div>

          <div class="navbar-button no-dropdown d-flex  flex-center">
            <i class="fas fa-bars"></i>
          </div>
        </div>
      </div>
    </div>
    <router-view/>
    <footer class="page-footer font-small black">

      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        <a href="https://mdbootstrap.com/"> Made with ♥ </a>
      </div>
      <!-- Copyright -->

    </footer>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        hasScrolled: false
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll(event) {
        this.hasScrolled = (event.target.scrollingElement.scrollTop > event.path[1].innerHeight)
      }
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');

  #app {
    overflow: hidden;
  }

  .navbar-container {
    height: 5rem;
    width: 100%;
    padding: 0.25rem;
    z-index: 1030;
    transition: 0.2s;
  }

  .navbar-container.low {
    height: 4rem;
  }

  .custom-navbar {
    background-color: white;
    width: 100%;
    border-radius: 2.5rem;
  }

  .navbar-logo {
    padding-left: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    cursor: pointer;
  }

  .navbar-button.no-dropdown:hover{
    border-radius: 2.5rem;
  }

  .navbar-button {
    background-color: white;
    font-size: 1.1em;
    min-width: 4.5rem;
    border-radius: 2.5rem;
    transition: all 0.2s;
    padding: 0 .75rem;
  }

  .navbar-button:hover {
    background-color: #eaeaea;
    cursor: pointer;
    border-radius: 0.75rem 0.75rem 0 0;
  }

  .fa-chevron-down {
    transition: 0.2s;
  }

  .navbar-button:hover .fa-chevron-down {
    transform: rotate(180deg);
  }

  .fa-chevron-down {
    margin-left: .5rem;
  }

  .dropdown-content{
    background-color: white;
    border-radius: 0 0 0.75rem 0.75rem;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    margin-top: -1rem;
    transition: all 0.3s;
  }

  .navbar-dropdown-button-container:hover .dropdown-content {
    visibility: visible;
    margin-top: 0;
    opacity: 1;
  }

  .dropdown-content .d-flex{
    height: 3rem;
    transition: all 0.2s;
  }

  .dropdown-content .d-flex:hover{
    font-size: 1.4rem;
    background-color: #eaeaea;
    cursor: pointer;
  }

  .navbar-dropdown-button-container{
    margin-left: 0.25rem ;
  }

  .custom-card {
    background-color: white;
    padding: 2rem;
    border-radius: 2rem;
    -webkit-box-shadow: 0 0 10px 2px rgba(10, 10, 10, 0.05);
    box-shadow: 0 0 10px 2px rgba(10, 10, 10, 0.05);
    transition: all 0.2s;
  }


  @media (max-width: 768px) {

  }

</style>
